(()=>{
  const root=document.querySelector('[data-it-calc-root]');
  if(!root||root.dataset.itScrapCalcV5==='1')return;
  root.dataset.itScrapCalcV5='1';

  const mode=(root.dataset.calcMode||'combined').toLowerCase();
  const metalSelect=root.querySelector('[data-metal-select]');
  const puritySelect=root.querySelector('[data-purity-select]');
  const unitSelect=root.querySelector('[data-unit-select]');
  const weightInput=root.querySelector('[data-weight-input]');
  const resultEl=root.querySelector('[data-result]');
  const resultCopy=root.querySelector('[data-result-copy]');
  const rateMeta=root.querySelector('[data-rate-meta]');
  const statusEl=root.querySelector('[data-pricing-status]');
  const statusDetail=root.querySelector('[data-pricing-detail]');
  const CACHE_KEY='it_precious_reference_v4';
  const FRESH_MS=45*60*1000;
  const STALE_MS=2*60*60*1000;
  const FUTURE_TOLERANCE_MS=5*60*1000;
  const REQUEST_TIMEOUT_MS=8000;
  const OUNCE_G=31.1034768;
  const currentRates={gold:null,silver:null};

  const goldPurities=[
    {value:.375,label:'9ct / 9K / 375'},
    {value:.585,label:'14ct / 14K / 585'},
    {value:.75,label:'18ct / 18K / 750'},
    {value:.916,label:'22ct / 22K / 916'},
    {value:.999,label:'24ct / 24K / 999'}
  ];
  const silverPurities=[
    {value:.925,label:'Sterling Silver / 925'},
    {value:.958,label:'Britannia Silver / 958'},
    {value:.999,label:'Fine Silver / 999'},
    {value:.9,label:'900 silver'},
    {value:.8,label:'800 silver'},
    {value:.5,label:'500 silver'}
  ];

  const validRate=n=>Number.isFinite(n)&&n>0&&n<10000;
  const validTimestamp=ts=>Number.isFinite(ts)&&ts>0&&ts<=Date.now()+FUTURE_TOLERANCE_MS;
  const ageOf=ts=>Date.now()-ts;
  const sourceForAge=(base,ts)=>{
    if(!validTimestamp(ts))return null;
    const age=ageOf(ts);
    if(age< -FUTURE_TOLERANCE_MS||age>STALE_MS)return null;
    return age<=FRESH_MS?`${base}-fresh`:`${base}-recent`;
  };
  const isFreshSource=source=>/-(fresh)$/.test(source||'')||source==='live';
  const unit=()=>unitSelect?.value||'g';
  const enteredWeight=()=>Number(weightInput?.value||0);
  const calculatorWeightGrams=()=>{const w=enteredWeight();return unit()==='oz'?w*OUNCE_G:w;};
  const selectedMetal=()=>metalSelect?.value||mode||'gold';
  const selectedRateObject=()=>currentRates[selectedMetal()]||null;
  const selectedRate=()=>selectedRateObject()?.value||null;
  const money=value=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2}).format(value);
  const rateMoney=value=>`£${value.toFixed(2)}/g`;

  const rebuildPurities=()=>{
    if(!puritySelect||!metalSelect)return;
    const values=metalSelect.value==='silver'?silverPurities:goldPurities;
    const previous=Number(puritySelect.value);
    puritySelect.innerHTML='';
    values.forEach(item=>{
      const option=document.createElement('option');
      option.value=String(item.value);
      option.textContent=item.label;
      puritySelect.appendChild(option);
    });
    if(values.some(item=>item.value===previous))puritySelect.value=String(previous);
  };

  const readCache=()=>{
    try{
      const parsed=JSON.parse(sessionStorage.getItem(CACHE_KEY)||'null');
      const ts=Number(parsed?.ts);
      const source=sourceForAge('cache',ts);
      if(!parsed||!source)return null;
      const out={ts,source};
      if(validRate(Number(parsed.gold)))out.gold=Number(parsed.gold);
      if(validRate(Number(parsed.silver)))out.silver=Number(parsed.silver);
      return out.gold||out.silver?out:null;
    }catch(_){return null;}
  };
  const writeCache=()=>{
    try{
      const freshest=['gold','silver'].map(m=>currentRates[m]).filter(Boolean).sort((a,b)=>b.ts-a.ts)[0];
      if(!freshest)return;
      const payload={ts:freshest.ts};
      if(currentRates.gold?.value)payload.gold=currentRates.gold.value;
      if(currentRates.silver?.value)payload.silver=currentRates.silver.value;
      sessionStorage.setItem(CACHE_KEY,JSON.stringify(payload));
    }catch(_){}
  };
  const setRate=(metal,value,source,ts)=>{
    if(!validRate(value)||!validTimestamp(ts))return false;
    const existing=currentRates[metal];
    if(existing&&existing.ts>ts)return false;
    currentRates[metal]={value,source,ts};
    return true;
  };

  const loadServerReference=()=>{
    const ts=Date.parse(root.dataset.ssrUpdated||'');
    const declaredState=root.dataset.ssrState||'unavailable';
    if(!validTimestamp(ts)||declaredState==='unavailable')return;
    const source=sourceForAge('server',ts);
    if(!source)return;
    setRate('gold',Number(root.dataset.ssrGold||''),source,ts);
    setRate('silver',Number(root.dataset.ssrSilver||''),source,ts);
  };
  const applyCache=()=>{
    const cache=readCache();
    if(!cache)return;
    if(cache.gold)setRate('gold',cache.gold,cache.source,cache.ts);
    if(cache.silver)setRate('silver',cache.silver,cache.source,cache.ts);
  };

  const pricingMessage=()=>{
    const rate=selectedRateObject();
    if(rate&&isFreshSource(rate.source)){
      return{title:'Current spot pricing loaded',detail:'Using a current fine-metal reference and GBP conversion. Values remain indicative, not a purchase offer.',tone:'current'};
    }
    if(rate){
      return{title:'Recent reference pricing shown',detail:'The current feed is temporarily unavailable, so a recent reference within the permitted two-hour fallback window is shown.',tone:'recent'};
    }
    return{title:'Current pricing unavailable',detail:'No sufficiently recent pricing reference is available. Try again shortly or request a specialist valuation.',tone:'error'};
  };
  const applyStatus=()=>{
    const msg=pricingMessage();
    if(statusEl){statusEl.textContent=msg.title;statusEl.dataset.tone=msg.tone;}
    if(statusDetail)statusDetail.textContent=msg.detail;
  };

  const calculate=(sendEvent=true)=>{
    const metal=selectedMetal();
    const purity=Number(puritySelect?.value||0);
    const rawWeight=enteredWeight();
    const grams=calculatorWeightGrams();
    const rate=selectedRate();
    if(!rawWeight||rawWeight<=0){
      if(resultEl)resultEl.textContent='£0.00';
      if(resultCopy)resultCopy.textContent='Enter a weight to calculate the estimated intrinsic value at the available reference price.';
      return;
    }
    if(!rate){
      if(resultEl)resultEl.textContent='Unavailable';
      if(resultCopy)resultCopy.textContent='No sufficiently recent reference price is available, so no metal value has been calculated.';
      return;
    }
    const value=grams*purity*rate;
    if(resultEl)resultEl.textContent=money(value);
    if(resultCopy)resultCopy.textContent=`${rawWeight.toLocaleString('en-GB')} ${unit()==='oz'?'troy oz':'g'} of ${(purity*100).toFixed(1)}% ${metal} × ${rateMoney(rate)} fine-metal reference.`;
    if(sendEvent){
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:'scrap_calculator_calculate',calculator_mode:mode,metal,purity:String(purity),weight_unit:unit(),weight_band:grams<10?'<10g':grams<50?'10-49.99g':grams<100?'50-99.99g':grams<250?'100-249.99g':'250g+'});
    }
  };

  const updateDisplay=()=>{
    ['gold','silver'].forEach(metal=>{
      const rate=currentRates[metal]?.value;
      root.querySelectorAll(`[data-fine-rate="${metal}"]`).forEach(el=>el.textContent=rate?rateMoney(rate):'Unavailable');
      root.querySelectorAll(`[data-table-value][data-metal="${metal}"]`).forEach(el=>{
        const purity=Number(el.dataset.purity||0);
        el.textContent=rate&&purity?rateMoney(rate*purity):'Unavailable';
      });
    });
    const active=selectedRateObject();
    if(rateMeta){
      if(active?.ts){
        const label=isFreshSource(active.source)?'Reference checked':'Recent reference stored';
        rateMeta.textContent=`${label} ${new Date(active.ts).toLocaleString('en-GB')}`;
      }else rateMeta.textContent='No sufficiently recent rate reference is available.';
    }
    root.querySelectorAll('[data-example-value]').forEach(el=>{
      const metal=el.dataset.metal||'gold';
      const rate=currentRates[metal]?.value;
      const grams=Number(el.dataset.weight||0);
      const purity=Number(el.dataset.purity||0);
      el.textContent=rate?money(rate*grams*purity):'Unavailable';
    });
    applyStatus();
    calculate(false);
    document.dispatchEvent(new CustomEvent('imperial:precious-rates',{detail:{gold:currentRates.gold,silver:currentRates.silver}}));
  };

  const fetchJson=async url=>{
    const controller=new AbortController();
    const timer=setTimeout(()=>controller.abort(),REQUEST_TIMEOUT_MS);
    try{
      const response=await fetch(url,{cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal});
      if(!response.ok)throw new Error(`HTTP ${response.status}`);
      return await response.json();
    }finally{clearTimeout(timer);}
  };
  const getSpot=async symbol=>{
    const data=await fetchJson(`https://api.gold-api.com/price/${symbol}`);
    const value=Number(data?.price);
    if(!validRate(value))throw new Error('Invalid spot response');
    return value;
  };
  const getFx=async()=>{
    try{
      const data=await fetchJson('https://api.frankfurter.dev/v2/rate/USD/GBP');
      const value=Number(data?.rate);
      if(!value||value<0.1||value>5)throw new Error('Invalid FX response');
      return value;
    }catch(_){
      const data=await fetchJson('https://api.frankfurter.dev/v1/latest?base=USD&symbols=GBP');
      const value=Number(data?.rates?.GBP);
      if(!value||value<0.1||value>5)throw new Error('Invalid FX fallback');
      return value;
    }
  };
  const refreshRequired=metal=>{
    const rate=currentRates[metal];
    return !rate||!isFreshSource(rate.source)||ageOf(rate.ts)>FRESH_MS;
  };
  const refresh=async()=>{
    const needed=mode==='combined'?['gold','silver']:[mode];
    const symbols={gold:'XAU',silver:'XAG'};
    const targets=needed.filter(refreshRequired);
    if(!targets.length){updateDisplay();return;}
    if(statusEl){statusEl.textContent='Refreshing current pricing…';statusEl.dataset.tone='loading';}
    const fxPromise=getFx();
    const settled=await Promise.allSettled(targets.map(async metal=>{
      const [usdOz,fx]=await Promise.all([getSpot(symbols[metal]),fxPromise]);
      const fineGbpGram=(usdOz*fx)/OUNCE_G;
      setRate(metal,fineGbpGram,'live',Date.now());
    }));
    if(settled.some(item=>item.status==='fulfilled'))writeCache();
    updateDisplay();
  };

  root.querySelectorAll('[data-calc-cta] a').forEach(link=>link.addEventListener('click',()=>{
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event:'scrap_calculator_cta_click',calculator_mode:mode,link_url:link.getAttribute('href')||'',link_text:(link.textContent||'').trim().slice(0,80)});
  }));
  metalSelect?.addEventListener('change',()=>{rebuildPurities();calculate(false);updateDisplay();refresh();});
  puritySelect?.addEventListener('change',()=>calculate(false));
  weightInput?.addEventListener('input',()=>calculate(false));
  unitSelect?.addEventListener('change',()=>calculate(false));

  loadServerReference();
  applyCache();
  rebuildPurities();
  updateDisplay();
  refresh();
})();
